import React from 'react';
import { useAppState } from '../../core/redux/hooks';
import { Message } from '../../localization/models';


/**
 * A React Hook for retrieving a message object from the app state project translations/messages.
 * Use this if you need information about the message like whether it contains HTML markup.
 * Use `useProjMsgText` if you just need the message string.
 */
export const useProjMsg = (str: string | number): Message | undefined => {
  const translations = useAppState(state => (state.projectMsgs || {})[state.locale.lang.languageId]);
  return React.useMemo<Message>(() => (translations ?? {})[str], [str, translations]);
};


/**
 * A React Hook for reading a translated string from the app state project translations/messages
 */
export const useProjMsgText = (
  str: string | number,
  defaultMsg: string  = '',
): string => useProjMsg(str)?.text ?? defaultMsg;
